import React from 'react';
import { fabric } from 'fabric';
import __ from './../utils/translation';
import './CustomImage.css'
import dinPart1 from '../default-images/mesh basket.11.png'
import dinPart2 from '../default-images/mesh basket.13.png'
import dinPart3 from '../default-images/mesh basket.14.png'
import dinPart4 from '../default-images/mesh basket.15.png'
import dinPart5 from '../default-images/mesh basket.16.png'
import dinPart6 from '../default-images/mesh basket.17.png'
import dinPart7 from '../default-images/mesh-basket-rod.16.png'
import dinPart8 from '../default-images/mesh-basket.161.png'
import dinPart9 from '../default-images/parts.1.png'
import dinPart10 from '../default-images/parts.2.png'
import dinPart11 from '../default-images/parts.3.png'
import dinPart12 from '../default-images/parts.4.png'
import dinPart13 from '../default-images/parts.5.png'
import dinPart14 from '../default-images/parts.7.png'
import dinPart15 from '../default-images/parts.8.png'






const CustomImage = ({ canvas }) => {
  const handleImgAdd = (e) => {
    const imageLink = e.target.src;
    let src = imageLink;
    fabric.Image.fromURL(src, (img) => {
      img.set({left: 50, top: 50})
      img.scaleToHeight(200)
      img.scaleToWidth(300)
      canvas.add(img)
      canvas.renderAll()
      canvas.trigger('object:modified')
    })
  }
  return (
      <>
        <p className="title">Basket Types</p>
        <div className="my-new-settings">
        <div className="Img__default">
            <section id='photos'>
              <img onClick={handleImgAdd} src={dinPart1} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart2} alt='Testing' />
              <img onClick={handleImgAdd} src={dinPart3} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart4} alt='Testing' />
              <img onClick={handleImgAdd} src={dinPart5} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart6} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart7} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart8} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart9} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart10} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart11} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart12} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart13} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart14} alt='Testing'/>
              <img onClick={handleImgAdd} src={dinPart15} alt='Testing'/>
            </section>
          </div>
        </div>
      </>
  )
}

export default CustomImage
